export function Thumbnail({
  url,
  alt,
  className = "",
}: {
  url: string | null;
  alt: string;
  className?: string;
}) {
  if (url) {
    return (
      <img
        src={url}
        alt={alt}
        className={`w-full h-full object-cover ${className}`}
        loading="lazy"
        onError={(e) => {
          (e.currentTarget as HTMLImageElement).style.display = "none";
        }}
      />
    );
  }
  // Placeholder: a neutral block with a play glyph.
  return (
    <div className={`w-full h-full bg-brand-line flex items-center justify-center ${className}`}>
      <svg width="40" height="40" viewBox="0 0 24 24" fill="#717171">
        <path d="M8 5v14l11-7z" />
      </svg>
    </div>
  );
}